(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  var ScaleBarBuilder = sbbNamespace.ScaleBarBuilder;
  var clamp = sbbNamespace.clamp;
  var parseNumber = sbbNamespace.parseNumber;
  var MM_PER_CM = sbbNamespace.mmPerCm;
  var MAX_DISTANCE_OFFSET_MM = sbbNamespace.maxDistanceOffsetMm;
  if (!ScaleBarBuilder || !clamp || !parseNumber || !MM_PER_CM || !MAX_DISTANCE_OFFSET_MM) {
    return;
  }

ScaleBarBuilder.prototype.pointInPolygon = function (xMm, yMm, vertices) {
    if (!Array.isArray(vertices) || vertices.length < 3) {
      return false;
    }
    var inside = false;
    for (var i = 0, j = vertices.length - 1; i < vertices.length; j = i, i += 1) {
      var xi = vertices[i].x;
      var yi = vertices[i].y;
      var xj = vertices[j].x;
      var yj = vertices[j].y;
      var intersects = ((yi > yMm) !== (yj > yMm)) && (xMm < ((xj - xi) * (yMm - yi)) / ((yj - yi) || 1e-9) + xi);
      if (intersects) {
        inside = !inside;
      }
    }
    return inside;
  };

  ScaleBarBuilder.prototype.getPointSegmentDistanceMm = function (px, py, ax, ay, bx, by) {
    var vx = bx - ax;
    var vy = by - ay;
    var wx = px - ax;
    var wy = py - ay;
    var c1 = vx * wx + vy * wy;
    if (c1 <= 0) {
      return Math.sqrt((px - ax) * (px - ax) + (py - ay) * (py - ay));
    }
    var c2 = vx * vx + vy * vy;
    if (c2 <= c1) {
      return Math.sqrt((px - bx) * (px - bx) + (py - by) * (py - by));
    }
    var t = c1 / c2;
    var projX = ax + t * vx;
    var projY = ay + t * vy;
    return Math.sqrt((px - projX) * (px - projX) + (py - projY) * (py - projY));
  };

  ScaleBarBuilder.prototype.trySetPointerCapture = function (pointerId) {
    if (!this.canvas || typeof this.canvas.setPointerCapture !== 'function') {
      return false;
    }
    var pid = parseNumber(pointerId, NaN);
    if (!isFinite(pid)) {
      return false;
    }
    try {
      this.canvas.setPointerCapture(pid);
      return true;
    } catch (error) {
      return false;
    }
  };

  ScaleBarBuilder.prototype.tryReleasePointerCapture = function (pointerId) {
    if (!this.canvas || typeof this.canvas.releasePointerCapture !== 'function') {
      return false;
    }
    var pid = parseNumber(pointerId, NaN);
    if (!isFinite(pid)) {
      return false;
    }
    try {
      if (typeof this.canvas.hasPointerCapture !== 'function' || this.canvas.hasPointerCapture(pid)) {
        this.canvas.releasePointerCapture(pid);
      }
      return true;
    } catch (error) {
      return false;
    }
  };

  ScaleBarBuilder.prototype.getOverlayAlphaSample = function (src, u, v) {
    if (!src || !isFinite(u) || !isFinite(v)) {
      return 255;
    }
    var record = this.getOverlayImageRecord(src);
    if (!record || record.status !== 'ready' || !record.image || !record.image.width || !record.image.height) {
      return 255;
    }

    var cache = this.overlayAlphaCache.get(src);
    if (!cache) {
      var canvas = document.createElement('canvas');
      canvas.width = record.image.width;
      canvas.height = record.image.height;
      var cacheCtx = canvas.getContext('2d');
      cacheCtx.drawImage(record.image, 0, 0);
      cache = { canvas: canvas, ctx: cacheCtx, width: canvas.width, height: canvas.height };
      this.overlayAlphaCache.set(src, cache);
    }

    var px = clamp(Math.floor(u * (cache.width - 1)), 0, Math.max(0, cache.width - 1));
    var py = clamp(Math.floor(v * (cache.height - 1)), 0, Math.max(0, cache.height - 1));
    var alpha = cache.ctx.getImageData(px, py, 1, 1).data[3];
    return alpha;
  };

  ScaleBarBuilder.prototype.overlayHitHasVisiblePixel = function (hr, xMm, yMm) {
    if (!hr || hr.kind !== 'overlay') {
      return true;
    }
    var overlay = this.findOverlayById(hr.id);
    if (!overlay || (overlay.type !== 'image' && overlay.type !== 'logo')) {
      return true;
    }

    var x = typeof overlay._computedXmm === 'number' ? overlay._computedXmm : overlay.xMm;
    var y = typeof overlay._computedYmm === 'number' ? overlay._computedYmm : overlay.yMm;
    var w = Math.max(2, overlay._computedWmm || overlay.wMm || 2);
    var h = Math.max(2, overlay._computedHmm || overlay.hMm || 2);
    var rot = this.normalizeRotation(overlay._computedRotationDeg || overlay.rotationDeg || 0);
    var cx = x + w / 2;
    var cy = y + h / 2;
    var rad = (-rot * Math.PI) / 180;
    var cos = Math.cos(rad);
    var sin = Math.sin(rad);
    var dx = xMm - cx;
    var dy = yMm - cy;
    var lx = dx * cos - dy * sin + cx;
    var ly = dx * sin + dy * cos + cy;
    if (lx < x || lx > x + w || ly < y || ly > y + h) {
      return false;
    }
    var u = (lx - x) / w;
    var v = (ly - y) / h;
    return this.getOverlayAlphaSample(overlay.srcDataUrl, u, v) > 12;
  };

  ScaleBarBuilder.prototype.hitRegionContainsPoint = function (hr, xMm, yMm) {
    if (!hr) {
      return false;
    }
    var hitTest = hr.hitTest || 'rect';
    if (hitTest === 'circle') {
      var dx = xMm - parseNumber(hr.cxMm, 0);
      var dy = yMm - parseNumber(hr.cyMm, 0);
      var r = Math.max(0.1, parseNumber(hr.rMm, 0));
      return dx * dx + dy * dy <= r * r;
    }
    if (hitTest === 'polygon') {
      return this.pointInPolygon(xMm, yMm, hr.vertices);
    }
    if (hitTest === 'rotated-rect') {
      if (!this.pointInPolygon(xMm, yMm, hr.vertices)) {
        return false;
      }
      return this.overlayHitHasVisiblePixel(hr, xMm, yMm);
    }
    if (hitTest === 'polyline') {
      if (!Array.isArray(hr.segments) || hr.segments.length === 0) {
        return false;
      }
      var toleranceMm = Math.max(0.3, parseNumber(hr.toleranceMm, 0.9));
      for (var i = 0; i < hr.segments.length; i += 1) {
        var seg = hr.segments[i];
        if (this.getPointSegmentDistanceMm(xMm, yMm, seg.x1, seg.y1, seg.x2, seg.y2) <= toleranceMm) {
          return true;
        }
      }
      return false;
    }
    return xMm >= hr.xMm && xMm <= hr.xMm + hr.wMm && yMm >= hr.yMm && yMm <= hr.yMm + hr.hMm;
  };

  ScaleBarBuilder.prototype.findTopHitRegionAt = function (paperX, paperY) {
    if (!this.hitRegions || this.hitRegions.length === 0) {
      return null;
    }
    var sorted = this.hitRegions.slice().sort(function (a, b) {
      return b.z - a.z;
    });

    for (var i = 0; i < sorted.length; i += 1) {
      var hr = sorted[i];
      if (this.hitRegionContainsPoint(hr, paperX, paperY)) {
        return hr;
      }
    }
    return null;
  };

  ScaleBarBuilder.prototype.cycleTagId = function (index, direction) {
    if (typeof index !== 'number' || index < 0 || index >= this.state.tagCount) {
      return;
    }

    var used = {};
    var reserved = this.getReservedTagIdMapForCurrentScope();
    for (var i = 0; i < this.state.tagCount; i += 1) {
      if (i === index) {
        continue;
      }
      used[this.state.tags[i].id] = true;
    }

    var currentId = this.state.tags[index].id;
    var idBounds = this.getCurrentTagIdBounds(this.state.tagType, this.state.tagFamily);
    if (direction > 0) {
      if (currentId >= idBounds.max) {
        this.state.tags[index].id = idBounds.max;
      } else {
        this.state.tags[index].id = this.findNextUniqueViableTagId(currentId + 1, used, reserved);
      }
    } else {
      if (currentId <= idBounds.min) {
        this.state.tags[index].id = idBounds.min;
      } else {
        this.state.tags[index].id = this.findPrevUniqueViableTagId(currentId, used, reserved);
      }
    }

    this.syncDynamicRows();
    this.render();
    this.commitHistory();
  };

  ScaleBarBuilder.prototype.isManualCutDrawArmed = function () {
    if (this.sanitizeCutShapeMode(this.state.cutShapeMode) !== 'manual') {
      return false;
    }
    if (!this.state.selectedEntity || this.state.selectedEntity.type !== 'cut') {
      return false;
    }
    var manual = this.getCutManualState();
    return manual.tool === 'draw' && !manual.closed;
  };

  ScaleBarBuilder.prototype.updateCanvasCursor = function () {
    if (!this.canvas) {
      return;
    }
    var cursor = 'default';
    if (this.dragState && this.dragState.type === 'pan') {
      cursor = 'grabbing';
    } else if (this.state.homeSetMode || this.isManualCutDrawArmed()) {
      cursor = 'crosshair';
    }
    this.canvas.style.cursor = cursor;
  };

  ScaleBarBuilder.prototype.snapCutManualCoordinate = function (valueMm, centerMm, paperLimitMm) {
    var out = parseNumber(valueMm, 0);
    var manual = this.getCutManualState();
    if (manual.showGrid && this.state.snapEnabled) {
      out = this.snapCenterToGrid(out, this.getGridStepMm(), centerMm);
    }
    return clamp(out, 0, paperLimitMm);
  };

  ScaleBarBuilder.prototype.handleManualCutPointerDown = function (pointer, event) {
    if (this.sanitizeCutShapeMode(this.state.cutShapeMode) !== 'manual') {
      return false;
    }
    var manual = this.getCutManualState();
    if (!manual || manual.tool !== 'draw') {
      return false;
    }
    if (manual.closed) {
      manual.tool = 'edit';
      this.state.cutManual = manual;
      this.manualCutPreviewPointerMm = null;
      return false;
    }
    if (event.button !== 0) {
      return false;
    }
    var paper = this.getPaper();
    var xMm = this.snapCutManualCoordinate(pointer.x, paper.width / 2, paper.width);
    var yMm = this.snapCutManualCoordinate(pointer.y, paper.height / 2, paper.height);
    var nodes = manual.nodes;
    if (nodes.length >= 3) {
      var first = nodes[0];
      var closeToleranceMm = Math.max(1.4, (10 * this.pixelRatio) / Math.max(0.0001, this.view ? this.view.scale : 1));
      var dClose = Math.sqrt(Math.pow(xMm - first.x, 2) + Math.pow(yMm - first.y, 2));
      if (dClose <= closeToleranceMm) {
        manual.closed = true;
        manual.tool = 'edit';
        manual.selectedPointIndex = 0;
        this.manualCutPreviewPointerMm = null;
        this.state.cutEditMode = 'manual';
        this.state.selectedEntity = { type: 'cut', id: 'cut-shape' };
        this.state.cutManual = manual;
        this.render();
        this.commitHistory();
        event.preventDefault();
        return true;
      }
    }

    nodes.push({
      x: xMm,
      y: yMm,
      inX: xMm,
      inY: yMm,
      outX: xMm,
      outY: yMm,
      pointType: 'corner'
    });
    manual.selectedPointIndex = nodes.length - 1;
    this.state.cutEditMode = 'manual';
    this.state.selectedEntity = { type: 'cut', id: 'cut-shape' };
    this.state.cutManual = manual;
    this.dragState = {
      type: 'cut-manual-new-point-handle',
      index: nodes.length - 1,
      anchorXmm: xMm,
      anchorYmm: yMm,
      pointerId: event.pointerId
    };
    this.trySetPointerCapture(event.pointerId);
    this.render();
    event.preventDefault();
    return true;
  };

  ScaleBarBuilder.prototype.handleDragMoveCutManualNewPointHandle = function (pointer, paper) {
    var manual = this.getCutManualState();
    var node = manual.nodes[this.dragState.index];
    if (!node) {
      return;
    }
    var xMm = this.snapCutManualCoordinate(pointer.x, paper.width / 2, paper.width);
    var yMm = this.snapCutManualCoordinate(pointer.y, paper.height / 2, paper.height);
    var dx = xMm - this.dragState.anchorXmm;
    var dy = yMm - this.dragState.anchorYmm;
    var dist = Math.sqrt(dx * dx + dy * dy);
    if (dist > 0.35) {
      node.outX = clamp(node.x + dx, 0, paper.width);
      node.outY = clamp(node.y + dy, 0, paper.height);
      node.inX = clamp(node.x - dx, 0, paper.width);
      node.inY = clamp(node.y - dy, 0, paper.height);
      node.pointType = 'bezier';
    } else {
      node.inX = node.x;
      node.inY = node.y;
      node.outX = node.x;
      node.outY = node.y;
      node.pointType = 'corner';
    }
    this.state.cutManual = manual;
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragMoveCutManualPoint = function (pointer, paper) {
    var manual = this.getCutManualState();
    var node = manual.nodes[this.dragState.index];
    if (!node) {
      return;
    }
    var xMm = this.snapCutManualCoordinate(pointer.x, paper.width / 2, paper.width);
    var yMm = this.snapCutManualCoordinate(pointer.y, paper.height / 2, paper.height);
    var dx = xMm - node.x;
    var dy = yMm - node.y;
    node.x = xMm;
    node.y = yMm;
    node.inX = clamp(parseNumber(node.inX, xMm) + dx, 0, paper.width);
    node.inY = clamp(parseNumber(node.inY, yMm) + dy, 0, paper.height);
    node.outX = clamp(parseNumber(node.outX, xMm) + dx, 0, paper.width);
    node.outY = clamp(parseNumber(node.outY, yMm) + dy, 0, paper.height);
    manual.selectedPointIndex = this.dragState.index;
    this.state.cutManual = manual;
    this.state.cutEditMode = 'manual';
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragMoveCutManualHandle = function (pointer, paper) {
    var manual = this.getCutManualState();
    var node = manual.nodes[this.dragState.index];
    if (!node) {
      return;
    }
    var xMm = this.snapCutManualCoordinate(pointer.x, paper.width / 2, paper.width);
    var yMm = this.snapCutManualCoordinate(pointer.y, paper.height / 2, paper.height);
    if (this.dragState.handle === 'in') {
      node.inX = xMm;
      node.inY = yMm;
    } else {
      node.outX = xMm;
      node.outY = yMm;
    }
    node.pointType = this.isCutManualNodeBezier(node) ? 'bezier' : 'corner';
    manual.selectedPointIndex = this.dragState.index;
    this.state.cutManual = manual;
    this.state.cutEditMode = 'manual';
    this.render();
  };

  // REGION: Pointer Interaction
  ScaleBarBuilder.prototype.handleCanvasPointerDown = function (event) {
    if (!this.view) {
      return;
    }

    if (this.inlineTextEditing) {
      this.stopInlineTextEditing(true);
    }

    var pointer = this.canvasToPaper(event, this.view);
    if (!pointer) {
      return;
    }

    if (this.state.homeSetMode) {
      var paper = this.getPaper();
      var home = this.getHomePoint();
      home.xMm = clamp(pointer.x, 0, paper.width);
      home.yMm = clamp(pointer.y, 0, paper.height);
      this.state.homeSetMode = false;
      this.state.selectedEntity = { type: 'home', id: 'home' };
      this.setStatus('HOME point updated.', false);
      this.render();
      this.commitHistory();
      event.preventDefault();
      return;
    }

    if (event.button === 1) {
      this.dragState = {
        type: 'pan',
        startXpx: pointer.xPx,
        startYpx: pointer.yPx,
        startCenterXmm: this.state.viewCenterXmm,
        startCenterYmm: this.state.viewCenterYmm,
        pointerId: event.pointerId
      };
      this.trySetPointerCapture(event.pointerId);
      event.preventDefault();
      return;
    }

    if (this.handleManualCutPointerDown(pointer, event)) {
      return;
    }

    var hit = this.findTopHitRegionAt(pointer.x, pointer.y);
    this.pointerDownEntity = hit;

    if (this.handlePointerDownImmediateAction(hit, event)) {
      return;
    }
    if (this.handlePointerDownDragStart(hit, pointer, event)) {
      return;
    }

    this.state.selectedEntity = null;
    this.render();
  };

  ScaleBarBuilder.prototype.handlePointerDownImmediateAction = function (hit, event) {
    if (!hit) {
      return false;
    }
    if (hit.kind === 'tag-id-prev') {
      this.cycleTagId(hit.index, -1);
      event.preventDefault();
      return true;
    }
    if (hit.kind === 'tag-id-next') {
      this.cycleTagId(hit.index, 1);
      event.preventDefault();
      return true;
    }
    if (hit.kind === 'tag-delete') {
      this.deleteTagAtIndex(hit.index);
      event.preventDefault();
      return true;
    }
    if (hit.kind === 'tag-toggle-relative') {
      this.state.showRelativeCoordinates = !this.state.showRelativeCoordinates;
      this.render();
      this.commitHistory();
      event.preventDefault();
      return true;
    }
    if (hit.kind === 'cut-move-toggle') {
      this.state.selectedEntity = { type: 'cut', id: 'cut-shape' };
      this.state.cutMoveUnlocked = !this.state.cutMoveUnlocked;
      this.setStatus(this.state.cutMoveUnlocked ? 'Cut region move unlocked.' : 'Cut region move locked.', false);
      this.render();
      this.commitHistory();
      event.preventDefault();
      return true;
    }
    if (hit.kind === 'guide-add-tag') {
      this.addTagAtGuide(hit.guideXmm, hit.guideYmm);
      event.preventDefault();
      return true;
    }
    return false;
  };

  ScaleBarBuilder.prototype.handlePointerDownDragStart = function (hit, pointer, event) {
    if (!hit) {
      return false;
    }
    if (hit.kind === 'tag-scale-corner') {
      return this.startTagScaleDragFromHit(hit, event);
    }
    if (hit.kind === 'home-point') {
      var home = this.getHomePoint();
      this.state.selectedEntity = { type: 'home', id: 'home' };
      this.dragState = {
        type: 'home',
        offsetXmm: pointer.x - home.xMm,
        offsetYmm: pointer.y - home.yMm,
        pointerId: event.pointerId
      };
      this.trySetPointerCapture(event.pointerId);
      this.render();
      event.preventDefault();
      return true;
    }
    if (hit.kind === 'cut-body') {
      this.state.selectedEntity = { type: 'cut', id: 'cut-shape' };
      if (this.sanitizeCutShapeMode(this.state.cutShapeMode) === 'manual') {
        this.render();
        event.preventDefault();
        return true;
      }
      if (this.state.cutMoveUnlocked) {
        this.dragState = {
          type: 'cut-body',
          startXmm: pointer.x,
          startYmm: pointer.y,
          pointerId: event.pointerId
        };
        this.trySetPointerCapture(event.pointerId);
      }
      this.render();
      event.preventDefault();
      return true;
    }
    if (hit.kind === 'cut-circle-handle') {
      this.state.selectedEntity = { type: 'cut', id: 'cut-shape' };
      this.dragState = {
        type: 'cut-circle-size',
        pointerId: event.pointerId
      };
      this.trySetPointerCapture(event.pointerId);
      this.render();
      event.preventDefault();
      return true;
    }
    if (hit.kind === 'cut-manual-point') {
      this.state.selectedEntity = { type: 'cut', id: 'cut-shape' };
      var manual = this.getCutManualState();
      manual.selectedPointIndex = clamp(parseNumber(hit.index, -1), -1, Math.max(-1, manual.nodes.length - 1));
      this.state.cutManual = manual;
      this.dragState = {
        type: 'cut-manual-point-move',
        index: hit.index,
        pointerId: event.pointerId
      };
      this.trySetPointerCapture(event.pointerId);
      this.render();
      event.preventDefault();
      return true;
    }
    if (hit.kind === 'cut-manual-handle-in' || hit.kind === 'cut-manual-handle-out') {
      this.state.selectedEntity = { type: 'cut', id: 'cut-shape' };
      var handleManual = this.getCutManualState();
      handleManual.selectedPointIndex = clamp(parseNumber(hit.index, -1), -1, Math.max(-1, handleManual.nodes.length - 1));
      this.state.cutManual = handleManual;
      this.dragState = {
        type: 'cut-manual-handle-move',
        index: hit.index,
        handle: hit.kind === 'cut-manual-handle-in' ? 'in' : 'out',
        pointerId: event.pointerId
      };
      this.trySetPointerCapture(event.pointerId);
      this.render();
      event.preventDefault();
      return true;
    }
    if (hit.kind === 'distance-annotation' || hit.kind === 'distance-annotation-line') {
      var parsedEdge = this.parseDistanceEdgeKey(hit.id);
      if (!parsedEdge) {
        return false;
      }
      this.state.selectedEntity = { type: 'distance', id: hit.id };
      this.dragState = {
        type: 'distance-annotation',
        edgeKey: hit.id,
        aIndex: parsedEdge.a,
        bIndex: parsedEdge.b,
        pointerId: event.pointerId
      };
      this.trySetPointerCapture(event.pointerId);
      this.render();
      event.preventDefault();
      return true;
    }
    if (hit.kind === 'rotate-handle') {
      return this.startRotateDragFromHit(hit, pointer, event);
    }
    if (hit.kind === 'overlay-scale-corner') {
      return this.startOverlayScaleDragFromHit(hit, event);
    }
    if (hit.kind === 'reference-handle-left' || hit.kind === 'reference-handle-right') {
      return this.startReferenceResizeDragFromHit(hit, event);
    }
    if (hit.kind === 'reference-handle-top' || hit.kind === 'reference-handle-bottom') {
      return this.startReferenceHeightResizeDragFromHit(hit, event);
    }
    if (hit.kind === 'reference') {
      return this.startReferenceMoveDragFromHit(hit, pointer, event);
    }
    if (hit.kind === 'overlay') {
      return this.startOverlayMoveDragFromHit(hit, pointer, event);
    }
    if (hit.kind === 'tag') {
      return this.startTagMoveDragFromHit(hit, pointer, event);
    }
    return false;
  };

  ScaleBarBuilder.prototype.startTagScaleDragFromHit = function (hit, event) {
    var scaleTag = this.state.tags[hit.index];
    if (!scaleTag) {
      return false;
    }
    this.state.selectedEntity = { type: 'tag', id: hit.index };
    this.dragState = {
      type: 'tag-scale',
      index: hit.index,
      pointerId: event.pointerId
    };
    this.trySetPointerCapture(event.pointerId);
    this.render();
    event.preventDefault();
    return true;
  };

  ScaleBarBuilder.prototype.startRotateDragFromHit = function (hit, pointer, event) {
    var rotateCenterX = null;
    var rotateCenterY = null;
    var initialRotation = 0;
    if (hit.entityType === 'overlay') {
      var rotateOverlay = this.findOverlayById(hit.id);
      if (rotateOverlay) {
        var ox = typeof rotateOverlay._computedXmm === 'number' ? rotateOverlay._computedXmm : rotateOverlay.xMm;
        var oy = typeof rotateOverlay._computedYmm === 'number' ? rotateOverlay._computedYmm : rotateOverlay.yMm;
        var ow = Math.max(2, rotateOverlay._computedWmm || rotateOverlay.wMm || 2);
        var oh = Math.max(2, rotateOverlay._computedHmm || rotateOverlay.hMm || 2);
        rotateCenterX = ox + ow / 2;
        rotateCenterY = oy + oh / 2;
        initialRotation = this.normalizeRotation(rotateOverlay.rotationDeg || 0);
        this.state.selectedEntity = { type: 'overlay', id: rotateOverlay.id };
      }
    } else if (hit.entityType === 'reference') {
      var rotateRef = this.getReferenceById(hit.id);
      if (rotateRef) {
        var rh = Math.max(1, Math.round(rotateRef.rows || 1)) * Math.max(0.2, rotateRef.cellHeightMm || this.state.checkerHeightMm);
        rotateCenterX = rotateRef.xMm + rotateRef.lengthMm / 2;
        rotateCenterY = rotateRef.yMm + rh / 2;
        initialRotation = this.normalizeRotation(rotateRef.rotationDeg || 0);
        this.state.selectedEntity = { type: 'reference', id: rotateRef.id };
      }
    }
    if (rotateCenterX === null || rotateCenterY === null) {
      return false;
    }
    this.dragState = {
      type: 'rotate',
      entityType: hit.entityType,
      id: hit.id,
      centerXmm: rotateCenterX,
      centerYmm: rotateCenterY,
      startAngleDeg: this.angleFromCenterDeg(rotateCenterX, rotateCenterY, pointer.x, pointer.y),
      initialRotationDeg: initialRotation,
      pointerId: event.pointerId
    };
    this.trySetPointerCapture(event.pointerId);
    this.render();
    event.preventDefault();
    return true;
  };

  ScaleBarBuilder.prototype.startOverlayScaleDragFromHit = function (hit, event) {
    var scaleOverlay = this.findOverlayById(hit.id);
    if (!scaleOverlay || (scaleOverlay.type !== 'text' && scaleOverlay.type !== 'image' && scaleOverlay.type !== 'logo' && scaleOverlay.type !== 'shape')) {
      return false;
    }
    var sx = typeof scaleOverlay._computedXmm === 'number' ? scaleOverlay._computedXmm : scaleOverlay.xMm;
    var sy = typeof scaleOverlay._computedYmm === 'number' ? scaleOverlay._computedYmm : scaleOverlay.yMm;
    var sw = Math.max(2, scaleOverlay._computedWmm || scaleOverlay.wMm || 2);
    var sh = Math.max(2, scaleOverlay._computedHmm || scaleOverlay.hMm || 2);
    var srot = this.normalizeRotation(scaleOverlay.rotationDeg || 0);
    var scorners = this.getRotatedRectCorners(sx, sy, sw, sh, srot);
    var oppositeByCorner = {
      tl: scorners.br,
      tr: scorners.bl,
      br: scorners.tl,
      bl: scorners.tr
    };
    var signByCorner = {
      tl: { sx: -1, sy: -1 },
      tr: { sx: 1, sy: -1 },
      br: { sx: 1, sy: 1 },
      bl: { sx: -1, sy: 1 }
    };
    this.state.selectedEntity = { type: 'overlay', id: scaleOverlay.id };
    this.dragState = {
      type: 'overlay-scale',
      id: scaleOverlay.id,
      corner: hit.corner,
      oppositePoint: oppositeByCorner[hit.corner],
      sign: signByCorner[hit.corner],
      rotationDeg: srot,
      startWidthMm: sw,
      startHeightMm: sh,
      centerPoint: { x: sx + sw / 2, y: sy + sh / 2 },
      startAspectRatio: sw / Math.max(0.1, sh),
      pointerId: event.pointerId
    };
    this.trySetPointerCapture(event.pointerId);
    this.render();
    event.preventDefault();
    return true;
  };

  ScaleBarBuilder.prototype.startReferenceResizeDragFromHit = function (hit, event) {
    var ref = this.getReferenceById(hit.id);
    if (!ref) {
      return false;
    }
    this.state.selectedEntity = { type: 'reference', id: ref.id };
    this.dragState = {
      type: 'reference-resize',
      id: ref.id,
      side: hit.kind === 'reference-handle-left' ? 'left' : 'right',
      fixedRightMm: hit.kind === 'reference-handle-left' ? ref.xMm + ref.lengthMm : undefined,
      fixedLeftMm: hit.kind === 'reference-handle-right' ? ref.xMm : undefined,
      startYmm: ref.yMm,
      pointerId: event.pointerId
    };
    this.trySetPointerCapture(event.pointerId);
    this.render();
    event.preventDefault();
    return true;
  };

  ScaleBarBuilder.prototype.startReferenceHeightResizeDragFromHit = function (hit, event) {
    var vRef = this.getReferenceById(hit.id);
    if (!vRef) {
      return false;
    }
    this.state.selectedEntity = { type: 'reference', id: vRef.id };
    this.dragState = {
      type: 'reference-height-resize',
      id: vRef.id,
      side: hit.kind === 'reference-handle-top' ? 'top' : 'bottom',
      pointerId: event.pointerId
    };
    this.trySetPointerCapture(event.pointerId);
    this.render();
    event.preventDefault();
    return true;
  };

  ScaleBarBuilder.prototype.startReferenceMoveDragFromHit = function (hit, pointer, event) {
    var ref = this.getReferenceById(hit.id);
    if (!ref) {
      return false;
    }
    var refRows = Math.max(1, Math.round(ref.rows || 1));
    var refTotalHeight = refRows * Math.max(0.2, ref.cellHeightMm || this.state.checkerHeightMm);
    var refCenterX = ref.xMm + ref.lengthMm / 2;
    var refCenterY = ref.yMm + refTotalHeight / 2;
    this.state.selectedEntity = { type: 'reference', id: ref.id };
    this.dragState = {
      type: 'reference-move',
      id: ref.id,
      offsetXmm: pointer.x - ref.xMm,
      offsetYmm: pointer.y - ref.yMm,
      offsetCenterXmm: pointer.x - refCenterX,
      offsetCenterYmm: pointer.y - refCenterY,
      pointerId: event.pointerId
    };
    this.trySetPointerCapture(event.pointerId);
    this.render();
    event.preventDefault();
    return true;
  };

  ScaleBarBuilder.prototype.startOverlayMoveDragFromHit = function (hit, pointer, event) {
    this.state.selectedEntity = { type: 'overlay', id: hit.id };
    var overlay = this.findOverlayById(hit.id);
    if (overlay && !overlay.locked) {
      var baseX = typeof overlay._computedXmm === 'number' ? overlay._computedXmm : overlay.xMm;
      var baseY = typeof overlay._computedYmm === 'number' ? overlay._computedYmm : overlay.yMm;
      var baseW = Math.max(2, overlay._computedWmm || overlay.wMm || 2);
      var baseH = Math.max(2, overlay._computedHmm || overlay.hMm || 2);
      var baseCenterX = baseX + baseW / 2;
      var baseCenterY = baseY + baseH / 2;
      this.dragState = {
        type: 'overlay',
        id: overlay.id,
        offsetXmm: pointer.x - baseX,
        offsetYmm: pointer.y - baseY,
        offsetCenterXmm: pointer.x - baseCenterX,
        offsetCenterYmm: pointer.y - baseCenterY,
        pointerId: event.pointerId
      };
      this.trySetPointerCapture(event.pointerId);
    }
    this.render();
    event.preventDefault();
    return true;
  };

  ScaleBarBuilder.prototype.startTagMoveDragFromHit = function (hit, pointer, event) {
    this.state.selectedEntity = { type: 'tag', id: hit.index };
    var tag = this.state.tags[hit.index];
    this.dragState = {
      type: 'tag',
      index: hit.index,
      offsetXmm: pointer.x - tag.xMm,
      offsetYmm: pointer.y - tag.yMm,
      pointerId: event.pointerId
    };
    this.trySetPointerCapture(event.pointerId);
    this.render();
    event.preventDefault();
    return true;
  };

  ScaleBarBuilder.prototype.handleCanvasDoubleClick = function (event) {
    if (!this.view) {
      return;
    }
    var pointer = this.canvasToPaper(event, this.view);
    if (!pointer) {
      return;
    }
    var hit = this.findTopHitRegionAt(pointer.x, pointer.y);
    if (hit && hit.kind === 'overlay') {
      var overlay = this.findOverlayById(hit.id);
      if (overlay && overlay.type === 'text') {
        this.state.selectedEntity = { type: 'overlay', id: overlay.id };
        this.startInlineTextEditing(overlay.id);
        this.render();
      }
    }
  };

  ScaleBarBuilder.prototype.handleCanvasPointerMove = function (event) {
    if (!this.view) {
      return;
    }

    var pointer = this.canvasToPaper(event, this.view);
    if (!pointer) {
      return;
    }

    var pointerChanged = false;
    if (this.isManualCutDrawArmed() && (!this.dragState || this.dragState.type !== 'cut-manual-new-point-handle')) {
      var paperPreview = this.getPaper();
      var previewX = this.snapCutManualCoordinate(pointer.x, paperPreview.width / 2, paperPreview.width);
      var previewY = this.snapCutManualCoordinate(pointer.y, paperPreview.height / 2, paperPreview.height);
      var preview = this.manualCutPreviewPointerMm;
      if (!preview || Math.abs(preview.x - previewX) > 0.02 || Math.abs(preview.y - previewY) > 0.02) {
        this.manualCutPreviewPointerMm = { x: previewX, y: previewY };
        pointerChanged = true;
      }
    } else if (this.manualCutPreviewPointerMm) {
      this.manualCutPreviewPointerMm = null;
      pointerChanged = true;
    }
    this.updateCanvasCursor();

    if (!this.dragState) {
      if (pointerChanged) {
        this.render();
      }
      return;
    }

    var paper = this.getPaper();
    var moveHandlers = {
      pan: this.handleDragPanView,
      home: this.handleDragMoveHome,
      tag: this.handleDragMoveTag,
      'tag-scale': this.handleDragMoveTagScale,
      'cut-body': this.handleDragMoveCutBody,
      'cut-circle-size': this.handleDragMoveCutCircleSize,
      'cut-manual-new-point-handle': this.handleDragMoveCutManualNewPointHandle,
      'cut-manual-point-move': this.handleDragMoveCutManualPoint,
      'cut-manual-handle-move': this.handleDragMoveCutManualHandle,
      overlay: this.handleDragMoveOverlay,
      'reference-move': this.handleDragMoveReference,
      'reference-resize': this.handleDragResizeReferenceLength,
      'reference-height-resize': this.handleDragResizeReferenceHeight,
      'overlay-scale': this.handleDragScaleOverlay,
      'distance-annotation': this.handleDragMoveDistanceAnnotation,
      rotate: this.handleDragRotateEntity
    };
    var handler = moveHandlers[this.dragState.type];
    if (handler) {
      handler.call(this, pointer, paper, event);
    }
  };

  ScaleBarBuilder.prototype.handleDragPanView = function (pointer) {
    if (!this.view) {
      return;
    }
    var paper = this.getPaper();
    var dxPx = pointer.xPx - this.dragState.startXpx;
    var dyPx = pointer.yPx - this.dragState.startYpx;
    var mmPerPx = 1 / Math.max(0.0001, this.view.scale);
    var nextCenterX = this.dragState.startCenterXmm - dxPx * mmPerPx;
    var nextCenterY = this.dragState.startCenterYmm - dyPx * mmPerPx;
    this.state.viewCenterXmm = clamp(nextCenterX, -paper.width, paper.width * 2);
    this.state.viewCenterYmm = clamp(nextCenterY, -paper.height, paper.height * 2);
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragMoveTag = function (pointer, paper) {
    var tag = this.state.tags[this.dragState.index];
    if (!tag) {
      return;
    }
    this.switchToManualMode();
    var half = this.getTagSizeMm(this.dragState.index) / 2;
    var printableTag = this.getPrintableRect(paper, half);
    var x = pointer.x - this.dragState.offsetXmm;
    var y = pointer.y - this.dragState.offsetYmm;
    x = this.snapMm(x, paper.width / 2);
    y = this.snapMm(y, paper.height / 2);
    tag.xMm = clamp(x, printableTag.minX, printableTag.maxX);
    tag.yMm = clamp(y, printableTag.minY, printableTag.maxY);
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragMoveHome = function (pointer, paper) {
    var home = this.getHomePoint();
    home.xMm = clamp(this.snapMm(pointer.x - this.dragState.offsetXmm, paper.width / 2), 0, paper.width);
    home.yMm = clamp(this.snapMm(pointer.y - this.dragState.offsetYmm, paper.height / 2), 0, paper.height);
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragMoveTagScale = function (pointer, paper) {
    var targetTag = this.state.tags[this.dragState.index];
    if (!targetTag) {
      return;
    }
    var dxScale = pointer.x - targetTag.xMm;
    var dyScale = pointer.y - targetTag.yMm;
    var halfScale = Math.max(Math.abs(dxScale), Math.abs(dyScale));
    var nextSize = clamp(Math.round((halfScale * 2) * 2) / 2, 8, 180);
    this.state.tagSizesMm[this.dragState.index] = nextSize;
    this.state.tagSizeMm = nextSize;
    var printableScale = this.getPrintableRect(paper, nextSize / 2);
    targetTag.xMm = clamp(targetTag.xMm, printableScale.minX, printableScale.maxX);
    targetTag.yMm = clamp(targetTag.yMm, printableScale.minY, printableScale.maxY);
    this.controls.tagSize.value = this.formatUiNumber(this.mmToUi(nextSize), this.state.unitSystem === 'imperial' ? 3 : 1);
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragMoveCutBody = function (pointer) {
    var bodyDx = pointer.x - this.dragState.startXmm;
    var bodyDy = pointer.y - this.dragState.startYmm;
    var moved = this.translateScene(bodyDx, bodyDy, {
      moveInfoOverlay: false,
      maxOverflowMm: 10
    });
    if (this.sanitizeCutShapeMode(this.state.cutShapeMode) === 'circle') {
      this.state.cutCircle = this.sanitizeCutCircle(this.state.cutCircle);
      this.state.cutCircle.centerXMm += moved.dx;
      this.state.cutCircle.centerYMm += moved.dy;
      this.state.cutCircle.initialized = true;
    }
    this.dragState.startXmm += moved.dx;
    this.dragState.startYmm += moved.dy;
    this.state.cutEditMode = 'manual';
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragMoveCutCircleSize = function (pointer, paper) {
    this.state.cutCircle = this.sanitizeCutCircle(this.state.cutCircle);
    var dx = pointer.x - this.state.cutCircle.centerXMm;
    var dy = pointer.y - this.state.cutCircle.centerYMm;
    var nextDiameter = Math.sqrt(dx * dx + dy * dy) * 2;
    var maxDiameter = Math.max(paper.width, paper.height) * 2;
    this.state.cutCircle.diameterMm = clamp(this.snapMm(nextDiameter, Math.min(paper.width, paper.height) / 2), 5, maxDiameter);
    this.state.cutCircle.initialized = true;
    this.state.cutEditMode = 'manual';
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragMoveOverlay = function (pointer, paper) {
    var overlay = this.findOverlayById(this.dragState.id);
    if (!overlay || overlay.locked) {
      return;
    }
    var overlayW = Math.max(2, overlay.wMm || 2);
    var overlayH = Math.max(2, overlay.hMm || 2);
    var centerX;
    var centerY;
    if (Number.isFinite(this.dragState.offsetCenterXmm) && Number.isFinite(this.dragState.offsetCenterYmm)) {
      centerX = pointer.x - this.dragState.offsetCenterXmm;
      centerY = pointer.y - this.dragState.offsetCenterYmm;
    } else {
      centerX = (pointer.x - this.dragState.offsetXmm) + overlayW / 2;
      centerY = (pointer.y - this.dragState.offsetYmm) + overlayH / 2;
    }
    centerX = this.snapMm(centerX, paper.width / 2);
    centerY = this.snapMm(centerY, paper.height / 2);
    var clampedCenter = this.clampRotatedRectCenterToPrintable(
      centerX,
      centerY,
      overlayW,
      overlayH,
      overlay.rotationDeg || 0,
      paper
    );
    overlay.xMm = clampedCenter.x - overlayW / 2;
    overlay.yMm = clampedCenter.y - overlayH / 2;
    if (overlay.id === this.logoOverlayId) {
      this.state.logoAutoPlacement = false;
    }
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragMoveReference = function (pointer, paper) {
    var movingRef = this.getReferenceById(this.dragState.id);
    if (!movingRef) {
      return;
    }
    var movingRefWidth = Math.max(0.2, movingRef.lengthMm || Math.max(0.2, movingRef.cellWidthMm || (this.state.checkerWidthCm * MM_PER_CM)));
    var movingRefHeight = Math.max(1, Math.round(movingRef.rows || 1)) * Math.max(0.2, movingRef.cellHeightMm || this.state.checkerHeightMm);
    var nextCenterX;
    var nextCenterY;
    if (Number.isFinite(this.dragState.offsetCenterXmm) && Number.isFinite(this.dragState.offsetCenterYmm)) {
      nextCenterX = pointer.x - this.dragState.offsetCenterXmm;
      nextCenterY = pointer.y - this.dragState.offsetCenterYmm;
    } else {
      nextCenterX = (pointer.x - this.dragState.offsetXmm) + movingRefWidth / 2;
      nextCenterY = (pointer.y - this.dragState.offsetYmm) + movingRefHeight / 2;
    }
    nextCenterX = this.snapMm(nextCenterX, paper.width / 2);
    nextCenterY = this.snapMm(nextCenterY, paper.height / 2);
    var clampedCenter = this.clampRotatedRectCenterToPrintable(
      nextCenterX,
      nextCenterY,
      movingRefWidth,
      movingRefHeight,
      movingRef.rotationDeg || 0,
      paper
    );
    movingRef.xMm = clampedCenter.x - movingRefWidth / 2;
    movingRef.yMm = clampedCenter.y - movingRefHeight / 2;
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragResizeReferenceLength = function (pointer, paper) {
    var resizeRef = this.getReferenceById(this.dragState.id);
    if (!resizeRef) {
      return;
    }
    var printableRef = this.getPrintableRect(paper, 0);
    var printableRefW = Math.max(0.2, printableRef.maxX - printableRef.minX);
    var unitMm = Math.max(0.2, resizeRef.cellWidthMm || (this.state.checkerWidthCm * MM_PER_CM));
    var rotRad = ((resizeRef.rotationDeg || 0) * Math.PI) / 180;
    var ux = Math.cos(rotRad);
    var uy = Math.sin(rotRad);
    var centerX = resizeRef.xMm + resizeRef.lengthMm / 2;
    var centerY = resizeRef.yMm + (Math.max(1, Math.round(resizeRef.rows || 1)) * resizeRef.cellHeightMm) / 2;
    var leftPoint = { x: centerX - ux * resizeRef.lengthMm / 2, y: centerY - uy * resizeRef.lengthMm / 2 };
    var rightPoint = { x: centerX + ux * resizeRef.lengthMm / 2, y: centerY + uy * resizeRef.lengthMm / 2 };

    if (this.dragState.side === 'right') {
      var projRight = (pointer.x - leftPoint.x) * ux + (pointer.y - leftPoint.y) * uy;
      var cellsRight = Math.max(1, Math.round(projRight / unitMm));
      var newLenRight = cellsRight * unitMm;
      newLenRight = clamp(newLenRight, unitMm, printableRefW);
      var newCenterRightX = leftPoint.x + ux * newLenRight / 2;
      var newCenterRightY = leftPoint.y + uy * newLenRight / 2;
      resizeRef.lengthMm = newLenRight;
      var rightRowsH = (Math.max(1, Math.round(resizeRef.rows || 1)) * resizeRef.cellHeightMm);
      var rightCenter = this.clampRotatedRectCenterToPrintable(
        newCenterRightX,
        newCenterRightY,
        newLenRight,
        rightRowsH,
        resizeRef.rotationDeg || 0,
        paper
      );
      resizeRef.xMm = rightCenter.x - newLenRight / 2;
      resizeRef.yMm = rightCenter.y - rightRowsH / 2;
    } else {
      var projLeft = (rightPoint.x - pointer.x) * ux + (rightPoint.y - pointer.y) * uy;
      var cellsLeft = Math.max(1, Math.round(projLeft / unitMm));
      var newLenLeft = cellsLeft * unitMm;
      newLenLeft = clamp(newLenLeft, unitMm, printableRefW);
      var newCenterLeftX = rightPoint.x - ux * newLenLeft / 2;
      var newCenterLeftY = rightPoint.y - uy * newLenLeft / 2;
      resizeRef.lengthMm = newLenLeft;
      var leftRowsH = (Math.max(1, Math.round(resizeRef.rows || 1)) * resizeRef.cellHeightMm);
      var leftCenter = this.clampRotatedRectCenterToPrintable(
        newCenterLeftX,
        newCenterLeftY,
        newLenLeft,
        leftRowsH,
        resizeRef.rotationDeg || 0,
        paper
      );
      resizeRef.xMm = leftCenter.x - newLenLeft / 2;
      resizeRef.yMm = leftCenter.y - leftRowsH / 2;
    }
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragResizeReferenceHeight = function (pointer, paper) {
    var heightRef = this.getReferenceById(this.dragState.id);
    if (!heightRef) {
      return;
    }
    var printableHeightRect = this.getPrintableRect(paper, 0);
    var hRows = Math.max(1, Math.round(heightRef.rows || 1));
    var hCell = Math.max(0.2, heightRef.cellHeightMm || this.state.checkerHeightMm);
    var hTotal = hRows * hCell;
    var hCenterX = heightRef.xMm + heightRef.lengthMm / 2;
    var hCenterY = heightRef.yMm + hTotal / 2;
    var hRotRad = ((heightRef.rotationDeg || 0) * Math.PI) / 180;
    var hCos = Math.cos(-hRotRad);
    var hSin = Math.sin(-hRotRad);
    var hDx = pointer.x - hCenterX;
    var hDy = pointer.y - hCenterY;
    var localY = hDx * hSin + hDy * hCos;
    var halfHeight = Math.max(0.3, Math.abs(localY));
    var printableHeight = Math.max(0.6, printableHeightRect.maxY - printableHeightRect.minY);
    var proposedTotalMm = clamp(halfHeight * 2, 0.6, printableHeight);
    var styleMode = heightRef.style || 'checker';
    var isRowStyle = this.isReferenceRowStyle(styleMode);

    if (isRowStyle) {
      var maxRowsByHeight = Math.max(1, Math.floor(printableHeight / Math.max(0.2, hCell)));
      var nextRows = clamp(Math.max(1, Math.round(proposedTotalMm / hCell)), 1, Math.min(32, maxRowsByHeight));
      heightRef.rows = nextRows;
    } else {
      heightRef.rows = 1;
      heightRef.cellHeightMm = clamp(proposedTotalMm, 0.6, printableHeight);
    }

    var appliedTotalMm = Math.max(0.2, heightRef.cellHeightMm) * Math.max(1, Math.round(heightRef.rows || 1));
    var hCenter = this.clampRotatedRectCenterToPrintable(
      hCenterX,
      hCenterY,
      heightRef.lengthMm,
      appliedTotalMm,
      heightRef.rotationDeg || 0,
      paper
    );
    heightRef.xMm = hCenter.x - heightRef.lengthMm / 2;
    heightRef.yMm = hCenter.y - appliedTotalMm / 2;
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragScaleOverlay = function (pointer, paper, event) {
    var scaleOverlay = this.findOverlayById(this.dragState.id);
    if (!scaleOverlay) {
      return;
    }
    var sign = this.dragState.sign;
    var opp = this.dragState.oppositePoint;
    var rot = ((this.dragState.rotationDeg || 0) * Math.PI) / 180;
    var cos = Math.cos(-rot);
    var sin = Math.sin(-rot);
    var forceUniformCenter = !!(event && event.shiftKey);
    var newW = 2;
    var newH = 2;
    var centerNew = null;
    var printableOverlay = this.getPrintableRect(paper, 0);
    var maxOverlayW = Math.max(2, printableOverlay.maxX - printableOverlay.minX);
    var maxOverlayH = Math.max(2, printableOverlay.maxY - printableOverlay.minY);
    var ratio = this.dragState.startAspectRatio || (this.dragState.startWidthMm / Math.max(0.1, this.dragState.startHeightMm));

    if (forceUniformCenter && this.dragState.centerPoint) {
      var cdx = pointer.x - this.dragState.centerPoint.x;
      var cdy = pointer.y - this.dragState.centerPoint.y;
      var localCx = cdx * cos - cdy * sin;
      var localCy = cdx * sin + cdy * cos;
      var halfW = Math.max(1, Math.abs(localCx));
      var halfH = Math.max(1, Math.abs(localCy));
      if (halfW / Math.max(0.1, halfH) > ratio) {
        halfW = halfH * ratio;
      } else {
        halfH = halfW / Math.max(0.1, ratio);
      }
      newW = halfW * 2;
      newH = halfH * 2;
      centerNew = {
        x: this.dragState.centerPoint.x,
        y: this.dragState.centerPoint.y
      };
    } else {
      var dx = pointer.x - opp.x;
      var dy = pointer.y - opp.y;
      var localX = dx * cos - dy * sin;
      var localY = dx * sin + dy * cos;
      newW = Math.max(2, sign.sx * localX);
      newH = Math.max(2, sign.sy * localY);
      if (scaleOverlay.preserveAspect) {
        if (newW / Math.max(0.1, newH) > ratio) {
          newW = newH * ratio;
        } else {
          newH = newW / Math.max(0.1, ratio);
        }
      }
      var finalLocalX = sign.sx * newW;
      var finalLocalY = sign.sy * newH;
      var fwCos = Math.cos(rot);
      var fwSin = Math.sin(rot);
      var worldVX = finalLocalX * fwCos - finalLocalY * fwSin;
      var worldVY = finalLocalX * fwSin + finalLocalY * fwCos;
      var cornerWorld = { x: opp.x + worldVX, y: opp.y + worldVY };
      centerNew = { x: (opp.x + cornerWorld.x) / 2, y: (opp.y + cornerWorld.y) / 2 };
    }

    newW = Math.min(newW, maxOverlayW);
    newH = Math.min(newH, maxOverlayH);

    scaleOverlay.wMm = newW;
    scaleOverlay.hMm = newH;
    var clampedOverlayCenter = this.clampRotatedRectCenterToPrintable(
      centerNew.x,
      centerNew.y,
      newW,
      newH,
      this.dragState.rotationDeg || 0,
      paper
    );
    scaleOverlay.xMm = clampedOverlayCenter.x - newW / 2;
    scaleOverlay.yMm = clampedOverlayCenter.y - newH / 2;
    if (scaleOverlay.id === this.logoOverlayId) {
      this.state.logoAutoPlacement = false;
    }
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragMoveDistanceAnnotation = function (pointer) {
    var tagA = this.state.tags[this.dragState.aIndex];
    var tagB = this.state.tags[this.dragState.bIndex];
    if (!tagA || !tagB) {
      return;
    }
    var edgeDx = tagB.xMm - tagA.xMm;
    var edgeDy = tagB.yMm - tagA.yMm;
    var edgeLen = Math.sqrt(edgeDx * edgeDx + edgeDy * edgeDy);
    if (edgeLen < 0.001) {
      return;
    }
    var edgeUx = edgeDx / edgeLen;
    var edgeUy = edgeDy / edgeLen;
    var keepoutA = this.getTagCenterKeepoutMm(this.getTagSizeMm(this.dragState.aIndex));
    var keepoutB = this.getTagCenterKeepoutMm(this.getTagSizeMm(this.dragState.bIndex));
    var minT = keepoutA / edgeLen;
    var maxT = 1 - (keepoutB / edgeLen);
    var vx = pointer.x - tagA.xMm;
    var vy = pointer.y - tagA.yMm;
    var rawT = (vx * edgeUx + vy * edgeUy) / edgeLen;
    var edgeNx = -edgeUy;
    var edgeNy = edgeUx;
    var rawOffset = vx * edgeNx + vy * edgeNy;
    var ann = this.getDistanceAnnotation(this.dragState.edgeKey);
    ann.t = clamp(rawT, minT, maxT);
    ann.normalOffsetMm = clamp(rawOffset, -MAX_DISTANCE_OFFSET_MM, MAX_DISTANCE_OFFSET_MM);
    this.state.distanceAnnotations[this.dragState.edgeKey] = ann;
    this.state.selectedEntity = { type: 'distance', id: this.dragState.edgeKey };
    this.render();
  };

  ScaleBarBuilder.prototype.handleDragRotateEntity = function (pointer) {
    var currentAngle = this.angleFromCenterDeg(this.dragState.centerXmm, this.dragState.centerYmm, pointer.x, pointer.y);
    var nextRotation = this.snapRotation15(this.dragState.initialRotationDeg + (currentAngle - this.dragState.startAngleDeg));
    var paper = this.getPaper();
    if (this.dragState.entityType === 'overlay') {
      var rotOverlay = this.findOverlayById(this.dragState.id);
      if (rotOverlay) {
        rotOverlay.rotationDeg = nextRotation;
        this.clampOverlayToPrintable(rotOverlay, paper);
      }
    } else if (this.dragState.entityType === 'reference') {
      var rotRef = this.getReferenceById(this.dragState.id);
      if (rotRef) {
        rotRef.rotationDeg = nextRotation;
        this.clampReferenceToPrintable(rotRef, paper);
      }
    }
    this.render();
  };

  ScaleBarBuilder.prototype.handleCanvasPointerUp = function (event) {
    if (this.dragState && this.dragState.pointerId === event.pointerId) {
      this.dragState = null;
      this.tryReleasePointerCapture(event.pointerId);
      this.syncDynamicRows();
      this.render();
      this.commitHistory();
    } else {
      this.updateCanvasCursor();
    }
  };

  ScaleBarBuilder.prototype.addTagAtGuide = function (xMm, yMm) {
    this.switchToManualMode();
    var paper = this.getPaper();
    var half = this.state.tagSizeMm / 2;
    var printable = this.getPrintableRect(paper, half);
    var snappedX = clamp(this.snapCenterToGrid(xMm, this.getGridStepMm(), paper.width / 2), printable.minX, printable.maxX);
    var snappedY = clamp(this.snapCenterToGrid(yMm, this.getGridStepMm(), paper.height / 2), printable.minY, printable.maxY);
    if (this.doesGuideOverlapExistingTag(snappedX, snappedY, this.state.tagSizeMm, null, this.state.tags)) {
      this.setStatus('Cannot add tag: placement overlaps an existing tag.', true);
      return;
    }
    var used = {};
    var reserved = this.getReservedTagIdMapForCurrentScope();
    for (var i = 0; i < this.state.tagCount; i += 1) {
      used[this.state.tags[i].id] = true;
    }

    this.state.tags.push({
      id: this.findNextUniqueViableTagId(0, used, reserved),
      xMm: snappedX,
      yMm: snappedY
    });
    this.ensureTagSizes();
    this.state.tagSizesMm.push(this.state.tagSizeMm);
    this.state.tagCount += 1;
    this.controls.tagCount.value = this.state.tagCount;
    this.syncDynamicRows();
    this.render();
    this.commitHistory();
  };

  ScaleBarBuilder.prototype.addTagFromToolbar = function () {
    var baseIndex = this.state.tagCount - 1;
    if (this.state.selectedEntity && this.state.selectedEntity.type === 'tag' && Number.isFinite(this.state.selectedEntity.id)) {
      baseIndex = clamp(this.state.selectedEntity.id, 0, Math.max(0, this.state.tagCount - 1));
    }
    var baseTag = this.state.tags[baseIndex];
    if (!baseTag) {
      return;
    }
    var spacingMm = Math.max(1, this.state.spacingCm * MM_PER_CM);
    var paper = this.getPaper();
    var half = this.state.tagSizeMm / 2;
    var printable = this.getPrintableRect(paper, half);
    var step = this.getGridStepMm();
    var candidates = [
      { x: baseTag.xMm + spacingMm, y: baseTag.yMm },
      { x: baseTag.xMm - spacingMm, y: baseTag.yMm },
      { x: baseTag.xMm, y: baseTag.yMm + spacingMm },
      { x: baseTag.xMm, y: baseTag.yMm - spacingMm }
    ];
    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = candidates[i];
      var snappedX = clamp(this.snapCenterToGrid(candidate.x, step, paper.width / 2), printable.minX, printable.maxX);
      var snappedY = clamp(this.snapCenterToGrid(candidate.y, step, paper.height / 2), printable.minY, printable.maxY);
      if (this.doesGuideOverlapExistingTag(snappedX, snappedY, this.state.tagSizeMm, null, this.state.tags)) {
        continue;
      }
      this.addTagAtGuide(snappedX, snappedY);
      return;
    }
    this.setStatus('Could not place a new tag without overlap. Move an existing tag and try again.', true);
  };
})();
